import React from 'react'
import Failure from "../../Assets/Images/failure.png"
import { useNavigate } from "react-router-dom";

const MyMedicineUploadFailure = () => {

    const navigate = useNavigate();
    return (
      <div className="test-success-container">
      <img src={Failure} alt="Success Tick Icon" className="tick-icon" />
      <p className="tsuccess-messages">Oops! Something went wrong with your
      lab report upload. Please try again.</p>
      <button className="thome-button" onClick={() => navigate('/home')}>Home</button>
    </div>
  )
}

export default MyMedicineUploadFailure